
import '~/assets/roboto.css'
export default {
    name: 'FairPayThirdPartyPayment',
    data() {
        return {
            timer: '--:--',
            interval: null,
            loading: true,
            isDepositSuccessful: false,
            isDepositFailed: null,
            qrImage: null,
            isExisting: null,
        }
    },
    computed: {
        checkExist() {
            return this.$store.state.themes.deposit.checkExist
        },
        paymentQrCodeImageLocalStorage() {
            const qrCodeLocalStorage = localStorage.getItem('qr_code')
            if (qrCodeLocalStorage) return qrCodeLocalStorage
            return null
        },
        playerProfile() {
            return this.$store.state.player.player
        },
    },
    watch: {
        checkExist(value) {
            this.isExisting = value.is_exist
            if (value.is_exist) {
                this.startTimer()
                this.displayQrImage()
            } else {
                this.isDepositFailed = true
            }
        },
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval)
        }
        // unsubscribe the store action
        if (this.subscribeAction) {
            this.subscribeAction()
        }
    },
    mounted() {
        // Fetch player profile to get the player name and player username to display in the page
        this.$store.dispatch('player/profile')

        this.displayQrImage()

        // To initialize the socket for confirm and decline deposit events
        this.initSocketTheme()
        // unsubscribe vuex mutation
        this.subscribeAction = this.$store.subscribeAction(
            (mutation, state) => {
                if (
                    mutation.type === 'sockets/revokeDepositByAdmin' ||
                    mutation.type === 'sockets/confirmDepositByAdmin' ||
                    mutation.type === 'sockets/successfulDeposit'
                ) {
                    if (
                        mutation.type === 'sockets/successfulDeposit' ||
                        mutation.type === 'sockets/confirmDepositByAdmin'
                    ) {
                        this.isDepositSuccessful = true
                    }
                    if (mutation.type === 'sockets/revokeDepositByAdmin') {
                        this.isDepositFailed = true
                    }
                    this.isExit()
                }
            }
        )

        this.isExit()
    },
    methods: {
        displayQrImage() {
            // To make sure if the deposit image (QR) is existing
            if (this.paymentQrCodeImageLocalStorage) {
                this.isDepositFailed = false
                // To check if the deposit id and the image qr code deposit id
                // are the same before displaying the QR code into the page
                if (this.checkExist.is_exist) {
                    const depositId =
                        this.paymentQrCodeImageLocalStorage.split(':')[0]
                    if (depositId === this.checkExist.id) {
                        this.qrImage =
                            this.paymentQrCodeImageLocalStorage.split(':')[1]
                    }
                }
            } else {
                // If the QR Code is not existing, then we set the deposit failed to true
                this.qrImage = null
                this.isDepositFailed = true
            }
        },
        startTimer() {
            this.displayTimer()
            if (this.internal) {
                clearInterval(this.internal)
            }
            this.interval = setInterval(() => {
                this.displayTimer()
            }, 1000)
        },
        async isExit() {
            this.loading = true
            await this.$store.dispatch('themes/deposit/checkExist')
            this.loading = false
        },
        displayTimer() {
            const start = this.$dayjs(
                decodeURIComponent(
                    this.checkExist?.created_at || this.$route.query.created_at
                ) // Ensure this is correct
            )
            const end = this.$dayjs()
            const duration = this.$dayjs.duration(end.diff(start))
            const minutes = duration.minutes()
            const seconds = duration.seconds()

            const currentDuration = this.$dayjs.duration({
                minutes,
                seconds,
            })

            // Define the total duration correctly and subtract 10 seconds
            const totalDuration = this.$dayjs
                .duration(10, 'minutes')
                .subtract(10, 'seconds')

            // Calculate time left
            const timeLeft = totalDuration.subtract(currentDuration)

            const minutesLeft = timeLeft.minutes()
            const secondsLeft = timeLeft.seconds()

            if (minutesLeft <= 0 && secondsLeft <= 1) {
                if (this.interval) {
                    clearInterval(this.interval)
                }
                this.timer = '00:00' // Set timer to 00:00
                this.isDepositFailed = true // Mark as failed when time is up
                this.isExisting = false
                return
            }

            // Format and update the timer display
            const minutesFormatted = minutesLeft.toString().padStart(2, '0')
            const secondsFormatted = secondsLeft.toString().padStart(2, '0')

            this.timer = `${minutesFormatted}:${secondsFormatted}`
        },
    },
}
